<template>
  <div class="add-form">
    <Form ref="addForm" :model="form" :rules="diyData.rules" :label-width="100">
      <div class="tag-title">赛事信息</div>
      <Row>
        <Col span="9">
          <FormItem label="标题" prop="title">
            <Input v-model="form.title" placeholder="请输入标题"></Input>
          </FormItem>
          <FormItem label="虚拟报名数" prop="virtual_count">
            <Input v-model="form.virtual_count" placeholder="请输入虚拟报名数"></Input>
          </FormItem>
          <FormItem label="报名时间" class="ivu-form-item-required">
            <DatePicker
              v-model="form.registration_time"
              format="yyyy-MM-dd"
              type="daterange"
              style="width: 100%"
              placement="bottom-end"
              placeholder="请选择报名时间"
            ></DatePicker>
          </FormItem>
          <FormItem label="比赛时间" class="ivu-form-item-required">
            <DatePicker
              v-model="form.game_time"
              format="yyyy-MM-dd"
              type="daterange"
              style="width: 100%"
              placement="bottom-end"
              placeholder="请选择报名时间"
            ></DatePicker>
          </FormItem>
          <FormItem label="赛事简介" prop="summary">
            <Input type="textarea" v-model="form.summary" placeholder="请输入赛事简介"></Input>
          </FormItem>
        </Col>
        <Col span="9">
          <FormItem label="指导单位" prop="guidance_unit">
            <Input v-model="form.guidance_unit" placeholder="请输入指导单位"></Input>
          </FormItem>
          <FormItem label="主办单位" prop="host">
            <Input v-model="form.host" placeholder="请输入主办单位"></Input>
          </FormItem>
          <FormItem label="承办单位" prop="undertake">
            <Input v-model="form.undertake" placeholder="请输入承办单位"></Input>
          </FormItem>
          <FormItem label="协办单位" prop="organizer">
            <Input type="textarea" v-model="form.organizer" placeholder="请输入协办单位"></Input>
          </FormItem>
          <FormItem label="赛事运营方" prop="operate">
            <Input v-model="form.operate" placeholder="请输入赛事运营方"></Input>
          </FormItem>
        </Col>
        <Col span="9">
          <FormItem label="赛事封面" prop="covers">
            <div class="upload-wrap">
              <div class="look-img" v-for="(item, index) in form.covers_url" :key="index">
                <img :src="item" style="width: 100%" />
                <div class="demo-upload-list-cover">
                  <Icon type="ios-eye-outline" @click.native="lookFile(item)"></Icon>
                  <Icon type="ios-trash-outline" @click.native="deleteFile(index)"></Icon>
                </div>
              </div>
              <upload-file-one
                :noPreview="true"
                @on-change="coversChange"
                tips="建议尺寸：500 * 312 px"
              ></upload-file-one>
            </div>
          </FormItem>
        </Col>
        <Col span="9">
          <FormItem label="排序" prop="sort">
            <Input type="number" v-model="form.sort" placeholder="请输入排序"></Input>
          </FormItem>
        </Col>

        <Col span="24">
          <FormItem label="报名模板" prop="registration_template_url">
            <upload-file-one
              :format="['xlsx']"
              :path="form.registration_template_url"
              :url="form.registration_template_url_url"
              @on-change="templateChange"
              type="file"
              tips="*支持格式：xlsx"
            ></upload-file-one>
          </FormItem>
        </Col>
      </Row>
      <div class="tag-title">赛事内容</div>
      <Row>
        <Col span="18">
          <FormItem label="赛事内容" prop="title">
            <editor v-model="form.content" width="375px"></editor>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <Button type="primary" style="width: 90px; margin-right: 20px" @click="submit">保存</Button>
    <Button style="width: 90px" @click="$router.go(-1)">取消</Button>
  </div>
</template>

<script>
import * as apiCompetition from '@/api/activity/competitions'
import uploadFileOne from '@/components/upload-custom/upload-file-one.vue'
import editor from '@/components/editor/editor.vue'
import _ from 'lodash'
import { getLoaclTime } from '@/libs/util'
export default {
  components: {
    uploadFileOne,
    editor
  },
  name: 'add-form',
  data () {
    return {
      query: {},
      search: {},
      diyDom: {},
      // 表单数据
      form: {
        title: '',
        summary: '', // 简介
        registration_time: [], // 报名时间
        game_time: [], // 比赛时间
        host: '', // 赛事主办
        organizer: '', // 赛事协办
        virtual_count: '0', // 虚拟报名
        covers: [], // 封面图
        covers_url: [], // 封面图预览
        content: '', // 赛事内容
        registration_template_url: '', // 报名模板
        registration_template_url_url: '', // 报名模板预览
        undertake: '', // 承办单位
        operate: '', // 运营单位
        guidance_unit: '', // 指导单位
        sort: '' // 排序
      },
      diyData: {
        rules: {
          title: [{ required: true, message: '赛事标题不能为空', triggier: 'blur' }],
          registration_start_time: [
            { required: true, type: 'date', message: '报名开始时间不能为空', triggier: 'change' }
          ],
          registration_end_time: [
            { required: true, type: 'date', message: '报名结束时间不能为空', triggier: 'change' }
          ],
          start_time: [{ required: true, type: 'date', message: '比赛结束时间不能为空', triggier: 'change' }],
          end_time: [{ required: true, type: 'date', message: '比赛结束时间不能为空', triggier: 'change' }],
          covers: [{ required: true, type: 'array', message: '赛事封面不能为空', triggier: 'change' }],
          registration_template_url: [{ required: true, message: '报名模板不能为空', triggier: 'change' }],
          content: [{ required: true, message: '赛事内容不能为空', triggier: 'change' }]
        }
      },
      apiData: {}
    }
  },
  computed: {},
  methods: {
    // 获取详情
    getDetail () {
      this.$store.commit('setSpinShow', true)
      apiCompetition
        .apiCompetitionsDetail(this.query.id)
        .then(res => {
          const { data } = res
          this.form.title = data.title
          this.form.summary = data.summary
          this.form.host = data.host
          this.form.organizer = data.organizer
          this.form.operate = data.operate
          this.form.sort = data.sort
          this.form.undertake = data.undertake
          this.form.guidance_unit = data.guidance_unit
          this.form.virtual_count = data.virtual_count || '0'
          this.form.covers = data.covers
          this.form.covers_url = data.covers_url
          this.form.content = data.content
          this.form.registration_template_url = data.registration_template_url
          this.form.registration_template_url_url = data.registration_template_url_url
          this.form.registration_time = [data.registration_start_time, data.registration_end_time]
          this.form.game_time = [data.start_time, data.end_time]
        })
        .finally(() => this.$store.commit('setSpinShow', false))
    },

    // 图片封面
    coversChange (data) {
      this.form.covers.push(data.path)
      this.form.covers_url.push(data.url)
    },
    // 查看文件
    lookFile (file) {
      const a = document.createElement('a')
      document.body.appendChild(a)
      a.target = '_blank'
      a.href = file
      a.click()
      document.body.removeChild(a)
    },
    // 删除文件
    deleteFile (index) {
      this.form.covers.splice(index, 1)
      this.form.covers_url.splice(index, 1)
    },
    // 模板变化
    templateChange (data) {
      this.form.registration_template_url = data.path
      this.form.registration_template_url_url = data.url
    },
    submit () {
      this.$refs['addForm'].validate(valid => {
        if (valid) {
          this.$store.commit('setSpinShow', true)
          let opt = _.cloneDeep(this.form)
          if (opt.registration_time.length < 1) return this.$Message.error('请选择报名时间')
          if (opt.game_time.length < 1) return this.$Message.error('请选择活动时间')
          opt.registration_start_time = getLoaclTime(this.form.registration_time[0])
          opt.registration_end_time = getLoaclTime(this.form.registration_time[1])
          opt.start_time = getLoaclTime(this.form.game_time[0])
          opt.end_time = getLoaclTime(this.form.game_time[1])
          if (this.query.id) {
            apiCompetition
              .apiCompetitionsEdit(this.query.id, opt)
              .then(res => {
                this.$Message.success('编辑赛事成功')
                this.$router.go(-1)
              })
              .finally(() => this.$store.commit('setSpinShow', false))
          } else {
            apiCompetition
              .apiCompetitionsAdd(opt)
              .then(res => {
                this.$Message.success('新增赛事成功')
                this.$router.go(-1)
              })
              .finally(() => this.$store.commit('setSpinShow', false))
          }
        }
      })
    }
  },
  mounted () {
    this.query = this.$route.query
    this.query.id && this.getDetail()
  }
}
</script>

<style scoped lang="less">
  .add-form {
    border: 1px solid #ededed;
    margin: 0 20px;
    padding: 26px 20px;

    .title {
      border-left: 5px solid #2d8cf0;
      padding: 0 0 0 10px;
      margin: 0 20px 20px;
      font-weight: bold;
    }
    .upload-wrap {
      display: flex;
    }
    .look-img {
      display: flex;
      margin-right: 10px;
      align-items: center;
      width: 150px;
      height: 150px;
      border: 1px dashed rgba(197, 197, 197, 1);
      text-align: center;
      justify-content: space-evenly;
      position: relative;
      overflow: hidden;
    }

    .demo-upload-list-cover {
      display: none;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.6);
      text-align: center;
    }

    .look-img:hover .demo-upload-list-cover {
      display: block;
    }

    .demo-upload-list-cover i {
      line-height: 150px;
      color: #fff;
      font-size: 20px;
      cursor: pointer;
      margin: 0 2px;
    }

    .demo-spin-icon-load {
      animation: ani-demo-spin 1s linear infinite;
    }
  }
</style>
